module.exports = __webpack_public_path__ + "media/application/images/ui/icon-footer-arrow-up-57cd10f6b3a366a945a650440c27453f.png";